<section>
  <div class="header list-header d-none d-md-block">
    <h1 class="d-inline-block v-align-middle">{{ 'COOPERATIVE_HOUSING.TRANSFER_LIST_HEADER' | translate }}</h1>
    @if (excelReady) {
      <app-excel-list
        class="btn-list-header"
        [columnDefinition]="excelColumnDefinition"
        [selectedListViewColumns]="selectedColumns"
        [excelContext]="excelContext"
        [filter]="filterState"
        [fileName]="excelFileName"
        [selectedIds]="selectedTransferIds"
        [affectedItemsCount]="selectedTransferCount"
        [allSelected]="allTransfersSelected"
        [totalResults]="totalTransfers"
      ></app-excel-list>
    }
  </div>
  <div class="header list-header d-flex d-md-none align-items-center">
    <h1 class="w-100">{{ 'COOPERATIVE_HOUSING.TRANSFER_LIST_HEADER' | translate }}</h1>
    @if (excelReady) {
      <app-excel-list
        [columnDefinition]="excelColumnDefinition"
        [selectedListViewColumns]="selectedColumns"
        [excelContext]="excelContext"
        [filter]="filterState"
        [fileName]="excelFileName"
        [selectedIds]="selectedTransferIds"
        [affectedItemsCount]="selectedTransferCount"
        [allSelected]="allTransfersSelected"
        [totalResults]="totalTransfers"
        [isMobile]="true"
      ></app-excel-list>
    }
  </div>
  <app-filter [filters]="filterDefinition" (change)="onFilterChange($event)" [defaultFilters]="defaultFilters"></app-filter>
  <app-multiselect-list-view
    [columnDefinition]="columnDefinition"
    [itemsSource]="itemsSource"
    [contextMenuDefinition]="contextMenuDefinition"
    [menuDefinition]="menuDefinition"
    [preferencesKey]="preferencesKey"
    [rememberPagination]="true"
    (onColumnChange)="onColumnChange($event)"
    (selectedItemsChange)="onSelectedTransfersChange($event)"
    (rowClick)="onRowClicked($event)"
    [isToolbarSticky]="true"
  >
  </app-multiselect-list-view>
</section>
